import React from 'react'
import { InputContainer } from '../../../../../common/components/form/form.module';

export default function ModalOneProgramComponent({ Close
    , mentors, handleItemSubmit, selectOnePrograms, onInnerBasicFormChange }: any) {


    return (

        <div className="  w-full p-2 bg-white shadow-md rounded-md">
            <h1 className="text-xl font-bold mb-4 text-center">Add One Program</h1>
            <div className=" grid md:grid-cols-2 lg:grid-cols-2 gap-4 border p-4">
                <InputContainer
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Name',

                        )
                    }}
                    type="text"
                    value={selectOnePrograms?.Name}
                />

                <InputContainer
                    label="Description"
                    name="Description"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Description',

                        )
                    }}
                    type="text"
                    value={selectOnePrograms?.Description}
                />

                <InputContainer
                    label="Program Duration"
                    name="ProgramDuration"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'ProgramDuration',

                        )
                    }}
                    type="text"
                    value={selectOnePrograms?.ProgramDuration}
                />

                <InputContainer
                    label="Mentor"
                    labelField="Name"
                    list={mentors}
                    onValueChange={(newValue: any) => {
                        const accessTypeValues: any = newValue.map((option: any) => option?.value || '')

                        onInnerBasicFormChange(accessTypeValues, 'MentorIds');
                    }}

                    type="multiselect"
                    value={selectOnePrograms?.MentorIds}
                    valueField="Id"
                />


                <InputContainer
                    label="Price"
                    name="Price"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Price',

                        )
                    }}
                    type="number"
                    value={selectOnePrograms?.Price}
                />

                
                <InputContainer

                    label="Enable"
                    name="IsEnabled"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event,
                            'IsEnabled'
                        )
                    }}
                    type="checkbox"
                    value={selectOnePrograms?.IsEnabled}
                />
                <InputContainer

                    label="Includes Activities"
                    name="IncludesActivities"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event,
                            'IncludesActivities'
                        )
                    }}
                    type="checkbox"
                    value={selectOnePrograms?.IncludesActivities}
                />



                {selectOnePrograms?.IncludesActivities ?
                    <div className='col-span-full'>

                        <InputContainer
                            label="Activities"
                            onValueChange={(newValue: any) => {
                                const valueData: any = newValue.map((option: any) => option?.id || '')
                                onInnerBasicFormChange(
                                    valueData,
                                    'Activities'

                                );
                            }}
                            type="multiselectText"
                            value={selectOnePrograms?.Activities}
                        />

                    </div> : null}
                <div className='col-span-full'>
                    <InputContainer
                        label="Specifications"
                        onValueChange={(newValue: any) => {
                            const valueData: any = newValue.map((option: any) => option?.id || '')
                            onInnerBasicFormChange(
                                valueData,
                                'Specifications'

                            );
                        }}
                        type="multiselectText"
                        value={selectOnePrograms?.Specifications}
                    />
                </div>

                <InputContainer
                    label="Start Date"
                    name="StartDateUtc"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'StartDateUtc'
                        )
                    }}
                    type="date"
                    value={selectOnePrograms?.StartDateUtc}
                />

                <InputContainer
                    label="End Date"
                    name="EndDateUtc"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'EndDateUtc'
                        )
                    }}
                    type="date"
                    value={selectOnePrograms?.EndDateUtc}
                />
            </div>

            <div className="flex justify-end mt-6">
                <button
                    onClick={Close}
                    type="button"
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                >
                    Close
                </button>
                <button
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                    onClick={handleItemSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>

        </div>



    )
}